import './TablaMonitoreoVistaProgramados.scss'
import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { formateoBasico } from '../../../utilities/formateos';
import Button from '../../atoms/Button/Button';
import ButtonGris from '../../atoms/ButtonGris/ButtonGris';
import { getDetallesServicios } from './TablaMonitoreoVistaProgramadosIntegracion';
import ModalDetalleServicio from './ModalDetalleServicio';
import useGetDataUser from '../../../CustomHooks/useGetDataUser';
const TablaMonitoreoVistaProgramados = ({ data, desde, hasta }) => {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [modalInfo, setModalInfo] = useState()
    const [dataModal, setDataModal] = useState(null)
    const userData = useGetDataUser()
    useEffect(() => {
        if (modalInfo) {
            getDetallesServicios(modalInfo, setDataModal)
        }
    }, [modalInfo])


    const bodyTotal = (rowData) => {

        return (
            rowData.CANCELADO == 0 ?
                <>
                    <td data-label="SERVICIOS"><div className="total">{rowData.SERVICIOS}</div></td>
                </> :
                <>
                    <td data-label="SERVICIOS"><div className="total" style={{background:"var(--red1)"}}>{rowData.SERVICIOS}</div></td>
                </>

        )
    }
    const edit = (rowData, key) => {
        return (
            <td data-label="SERVICIOS"><button className='buttonEdit' onClick={() => { setModalInfo(rowData.ID_SERVICIOS) }}>🖌️</button></td>
        )
    }
    
    return (
        <div className="TablaMonitoreoVistaProgramados">
            {/* <IconInput
                type="search"
                onChange={(e) => setGlobalFilter(e.target.value)}
                placeholder="Buscar..."
                icon={searchIcon}
            /> */}
            <div className="title">{"(ID RUTA: " + data[0]?.ID_RUTA + ") Periodo " + desde + " a " + hasta}</div>
            <DataTable
                value={data}
                globalFilter={globalFilter}
               

            >
                <Column field="SERVICIOS" header="Total" body={bodyTotal} />
                <Column field="NOMBRE_RUTA" header="Ruta" body={(rowData) => <td data-label="NOMBRE_RUTA">{rowData.NOMBRE_RUTA}</td>} />
                <Column field="PROVEEDOR_SERVICIO" header="Proveedor" body={(rowData) => <td data-label="PROVEEDOR_SERVICIO">{rowData.PROVEEDOR_SERVICIO}</td>} />
                <Column field="OPERADOR" header="Operador" body={(rowData) => <td data-label="OPERADOR">{rowData.OPERADOR}</td>} />
                <Column field="UNIDAD" header="Unidad" body={(rowData) => <td data-label="UNIDAD">{rowData.UNIDAD}</td>} />
                <Column field="CANCELADO" header="Cancelados" body={(rowData) => <td data-label="CANCELADO">{rowData.CANCELADO ? 'Si' : 'No'}</td>} />
                <Column field="APLICAR_FACTURA" header="Factura" body={(rowData) => <td data-label="APLICAR_FACTURA">{rowData.APLICAR_FACTURA}</td>} />
                <Column field="NO_APLICAR_FACTURA" header="No factura" body={(rowData) => <td data-label="NO_APLICAR_FACTURA">{rowData.NO_APLICAR_FACTURA}</td>} />
                <Column field="FECHA_INICIAL" header="Desde" body={(rowData) => <td data-label="FECHA_INICIAL">{formateoBasico(rowData.FECHA_INICIAL)}</td>} />
                <Column field="FECHA_FINAL" header="Hasta" body={(rowData) => <td data-label="FECHA_FINAL">{formateoBasico(rowData.FECHA_FINAL)}</td>} />
                {
                    userData?.ID == 3966&&(

                        <Column field="acciones" header="Acciones" body={edit} /> 
                    )
                }
            </DataTable>
            {dataModal ? <><ModalDetalleServicio data={dataModal} setDataModal={setDataModal} setModalInfo={setModalInfo}></ModalDetalleServicio></> : ""}
        </div>
    )
}
export default TablaMonitoreoVistaProgramados